
import { Component, Vue, Prop } from 'vue-property-decorator'
import { getKeys } from '~/lib/utils/utils'
import Icon from '~/components/common/icon/Icon.vue'

@Component({
  components: {
    Icon
  }
})
export default class StreakEventBarItem extends Vue {
  @Prop({ type: String, required: true }) status!: 'started' | 'completed' | 'missed'
  @Prop({ type: String, required: true }) occurredAt!: string

  events = {
    started: {
      title: 'Streak started',
      text: 'Complete your weekly goal.',
      shape: {
        classes: 'border-dashed border-prim-1 bg-gray-4'
      },
      icon: {
        fill: this.$tokens.color_coral,
        stroke: this.$tokens.color_coral
      }
    },
    completed: {
      title: 'Streak completed',
      text: 'Hooray! Another streak completed.',
      shape: {
        classes: 'border-solid border-prim-1 bg-prim-1'
      },
      icon: {
        fill: this.$tokens.color_white,
        stroke: this.$tokens.color_white
      }
    },
    missed: {
      title: 'Streak missed',
      text: 'You didn’t meet your weekly goal.',
      shape: {
        classes: 'border-solid border-oth-6 bg-oth-6'
      },
      icon: {
        fill: this.$tokens.color_white,
        stroke: this.$tokens.color_white
      }
    }
  }

  get event() {
    return this.events[this.status]
  }

  get ago() {
    const units = {
      day: 1000 * 60 * 60 * 24,
      hour: 1000 * 60 * 60,
      min: 1000 * 60,
      sec: 1000
    }

    const pl = ['day', 'hour']

    const passTimeMilliSec = Date.now() - Date.parse(this.occurredAt)
    const unitName = getKeys(units).find((unitName) => {
      return passTimeMilliSec / units[unitName] >= 1
    }) as keyof typeof units
    const result = Math.trunc(passTimeMilliSec / units[unitName])

    const plUnitName = pl.includes(unitName) ? this.$pluralize(unitName, result) : unitName

    return `${result} ${plUnitName} ago`
  }
}
